export const navs = [
    {
        id: 1,
        name: "Home",
        icon: "fa fa-fw fa-home text-xl",
        link: "/"
    },
    {
        id: 2,
        name: "IT skills",
        icon: "fa-solid fa-code text-xl",
        link: "/skills" 
    },
    {
        id: 3,
        name: "Education",
        icon: "fa fa-fw fa-user-graduate text-xl",
        link: "/education"
    },
    {
        id: 4,
        name: "Work Experince",
        icon: "fa fa-fw fa-briefcase text-xl",
        link: "/job"
    },
    {
        id: 5,
        name: "My other projects",
        icon: "fa fa-light fa-list-check text-xl",
        link: "/projects"
    },
]